import React, { memo, useCallback } from "react";
import styles from "../../Tax.module.scss";

/**
 * Radio button group for Active/Inactive state selection
 * Shows loading state while updating
 */
const ActiveInactiveRadio = memo(
  ({ value, onChange, isLoading = false, disabled = false }) => {
    const handleChange = useCallback(
      (newValue) => {
        if (!isLoading && !disabled) {
          // Create a synthetic event object similar to what the onChange expects
          const syntheticEvent = {
            target: { value: newValue },
          };
          onChange(syntheticEvent);
        }
      },
      [onChange, isLoading, disabled],
    );

    const isInteractionDisabled = isLoading || disabled;

    return (
      <div className={styles.formGroup}>
        <label className={styles.label}>Status</label>
        <div className={styles.radioGroup}>
          <label
            className={`${styles.radioLabel} ${isInteractionDisabled ? styles.disabled : ""}`}
          >
            <input
              type="radio"
              name="activeStatus"
              value="active"
              checked={value === "active"}
              onChange={() => handleChange("active")}
              disabled={isInteractionDisabled}
              className={styles.radioInput}
            />
            <span className={styles.radioText}>Active</span>
          </label>

          <label
            className={`${styles.radioLabel} ${isInteractionDisabled ? styles.disabled : ""}`}
          >
            <input
              type="radio"
              name="activeStatus"
              value="in-active"
              checked={value === "in-active"}
              onChange={() => handleChange("in-active")}
              disabled={isInteractionDisabled}
              className={styles.radioInput}
            />
            <span className={styles.radioText}>Inactive</span>
          </label>

          {isLoading && (
            <div className={styles.radioLoader}>
              <div className={styles.spinner}></div>
              <span>Updating...</span>
            </div>
          )}
        </div>
      </div>
    );
  },
);

ActiveInactiveRadio.displayName = "ActiveInactiveRadio";

export default ActiveInactiveRadio;
